import React from 'react';
import { connect } from "react-redux";
import * as fileCrud from '../../../../../crud/file.crud';
import axios from 'axios';
import * as paymentBatchCrud from '../../../../../crud/paymentBatch.crud';
import * as paymentCertificateCrud from '../../../../../crud/paymentCertificate.crud';
import * as projectOrderCrud from '../../../../../crud/projectOrder.crud';
import BaseDocument from '../../../_CustomComponents/BaseDocument';
import { withSnackbar } from 'notistack';
import { confirm } from 'devextreme/ui/dialog';
import { Portlet, PortletBody } from "../../../../../partials/content/Portlet";
import BiDynamicForm from '../../../../../partials/layout/BiDynamicForm';
import { actionCodes, GetCurrencyCodes } from "../../../../../shared/lookup";
import PortletSpinner from '../../../../../partials/layout/PortletSpinner';
import moment from 'moment';
import { ValidationGroup } from 'devextreme-react';
import { injectIntl } from "react-intl";
import Common from '../../../../../shared/common';

const rightAlignedNumberBox = {
    editorOptions: {
        elementAttr: { class: 'text-right' }
    }
};

const initialState = {
    currencies: null,
    batchDrafts: null,
    secondaryPricesLastRetainAmounts: null,
    projectOrders: null,
    fileUploading: false,
    files: null,
    lastPaymentAmountsRecalculated: false
}

class NotifyDocumentPage extends BaseDocument {
    constructor(props) {
        super(props);

        this.currencyCodes = GetCurrencyCodes(props.intl);
        if (props.workflowItem.config.currentModelType === "Application") {

            this.customFields = (props.allCustomFields || {})[21];
            if (props.placeholdersQA.ApplicationTypes) {
                this.configurableTypeFields = props.placeholdersQA.ApplicationTypes.values.filter(item => item.isActive === true).map(x => ({ value: x.field, display: x.display }));

            }
        }
        else if (props.workflowItem.config.currentModelType === "Certificate") {
            this.customFields = (props.allCustomFields || {})[20];
            if (props.placeholdersQA.PaymentTypes) {
                this.configurableTypeFields = props.placeholdersQA.PaymentTypes.values.filter(item => item.isActive === true).map(x => ({ value: x.field, display: x.display }));
            }
        }
        try {
            this.taxEnabled = props.placeholdersQA.TaxEnabled
                .values.find(phItem => phItem.field === 'TaxEnabled').isActive;
        } catch (error) {
            console.log("TaxEnabled placeholder not available!");
            this.taxEnabled = true;
        }
        try {
            this.poNumberEnabled = props.placeholdersQA.PONumberEnabled
                .values.find(phItem => phItem.field === 'PONumberEnabled').isActive;
        } catch (error) {
            console.log("PONumberEnabled placeholder not available!");
            this.poNumberEnabled = false;
        }

        this.validatorRef = React.createRef();

        this.batchPaymentForPackagedContractEnabled = props.contract.ispackaged;

        if (this.batchPaymentForPackagedContractEnabled) {
            this.projectOrderNotificationName = (this.props.workflowsQA['72'] || {}).notificationName;
        }

        this.batchWorkflowItem = props.workflowItem.config.currentModelType === 'Certificate' ?
            this.props.workflowsQA['78'] :
            this.props.workflowsQA['79'];

        this.communicateButtonEnabled = this.batchWorkflowItem?.userFilters?.mainNotice?.communicateAllowed;

        this.state = { ...initialState };
    }

    componentDidMount() {
        this.getDrafts();
    }

    componentDidUpdate(prevprops, prevSatate) {
        if (this.props.params?.notificationid !== prevprops.params?.notificationid) {
            this.setState({ ...initialState }, () => {
                this.getDrafts();
            });
        }
    }

    getDrafts = async () => {
        try {
            await this.props.closeSnackbar("PersistentFormWarning");
            const { data: batchDrafts } = await paymentBatchCrud.batchGetDrafts(this.props.paymentBatchId);

            const currencies = batchDrafts.flatMap(item => item.currencies || []);

            let projectOrders = null;

            let lastCertifiedReferences = null;

            if (this.batchPaymentForPackagedContractEnabled) {
                const projectOrderIds = batchDrafts.flatMap(item => item.projectorders || []);

                projectOrders = await this.fetchAndFilterProjectOrders(projectOrderIds);

                lastCertifiedReferences = await this.fetchLastPaymentAmountsForProjectOrders(projectOrderIds);
            } else {
                lastCertifiedReferences = await this.fetchLastPaymentAmountsForCurrencies(currencies);
            }

            let mappedBatchDrafts = this.mapBatchDrafts(batchDrafts, projectOrders);

            let hasAnyRecalculated = false;

            const validatedDrafts = mappedBatchDrafts.map((draft, index) => {
                const reference = lastCertifiedReferences[index];
                const expectedAmount = reference?.amount;

                console.log('Expected Amount:', expectedAmount);

                const lastPaymentCertificateAmountName = `lastpaymentcertificateamount${index + 1}`;

                const currentDraftLastPaymentCertificateAmount = draft[lastPaymentCertificateAmountName];

                console.log('Current Amount:', currentDraftLastPaymentCertificateAmount);

                if (
                    expectedAmount != null &&
                    currentDraftLastPaymentCertificateAmount !== expectedAmount
                ) {
                    hasAnyRecalculated = true;

                    // Update the draft object directly
                    //draft.lastpaymentcertificateamount = expectedAmount;
                    draft[lastPaymentCertificateAmountName] = expectedAmount;

                    const otherCertifiedPretaxName = `othercertifiedpretax${index + 1}`;
                    draft[otherCertifiedPretaxName] = this.calculateSubTotal(index + 1, draft);
                    //draft.othercertifiedpretax = calculateSubTotalPreTaxV2(draft);

                    const otherCertifiedAmountName = `othercertfiedamount${index + 1}`;
                    draft[otherCertifiedAmountName] = this.calculateDynamicTotal(index + 1, draft);
                    //draft.othercertfiedamount = calculateTotal(draft);
                }

                return draft;
            });

            // 3. Show Snackbar once if any item in the batch was updated
            if (hasAnyRecalculated) {
                this.props.enqueueSnackbar(
                    this.props.intl.formatMessage({ id: 'CONTRACT.WF.PAYMENT.WARNING.RECALCULATED' }),
                    { variant: "warning", key: "PersistentFormWarning", persist: true }
                );
            }

            let finalBatchDrafts = [];

            for (const draft of validatedDrafts) {
                let files = [];
                if (draft.paymentcertificateids && draft.paymentcertificateids.length > 0) {
                    // AWAIT ensures only one fetchFiles call is active at a time
                    files = await this.fetchFiles(draft.paymentcertificateids[0]);
                }
                finalBatchDrafts.push({ ...draft, files: files || [] });
            }

            this.setState({ batchDrafts: finalBatchDrafts, currencies, projectOrders, lastPaymentAmountsRecalculated: hasAnyRecalculated });
        }
        catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }
    }

    fetchLastPaymentAmountsForCurrencies = async (currencies) => {
        try {
            const contractId = this.props.contract.contractid;

            const { data } = await paymentCertificateCrud.getLastPaymentAmounts(
                contractId,
                ["Certificate"],
                currencies,
                ''
            );

            const secondaryPricesLastRetainAmounts = data || [];

            this.setState({ secondaryPricesLastRetainAmounts });

            return secondaryPricesLastRetainAmounts;
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to fetch last payment amounts for currencies', { variant: 'error', });
        }
    }

    fetchLastPaymentAmountsForProjectOrders = async (projectOrderIds) => {
        try {
            const contractId = this.props.contract.contractid;

            const { data } = await paymentCertificateCrud.getLastPaymentAmounts(
                contractId,
                ["Certificate"],
                [this.props.contract.currency],
                projectOrderIds
            );

            const secondaryPricesLastRetainAmounts = data || [];

            this.setState({ secondaryPricesLastRetainAmounts });

            return secondaryPricesLastRetainAmounts;
        } catch (err) {
            console.log(err);
        }
    };

    fetchAndFilterProjectOrders = async (projectOrderIds) => {
        try {
            const { contractid, ispackaged } = this.props.contract;
            const { data: responseObj } = await projectOrderCrud.getProjectOrdersToSelectList(contractid);

            const idsToFilter = Array.isArray(projectOrderIds) ? projectOrderIds : [];

            const filteredResponse = responseObj.filter(TO =>
                // Check if the current project order's ID is included in the input array
                idsToFilter.includes(TO.projectorderid)
            );

            const projectOrders = filteredResponse.map(TO => {
                let parts = [];

                if (ispackaged) {
                    // Project Code
                    if (TO.linkedprojectcode) {
                        parts.push(TO.linkedprojectcode);
                    }

                    // PO Number
                    if (TO.projectordernumber) {
                        parts.push(TO.projectordernumber);
                    }

                    // Project Name
                    if (TO.linkedprojectname) {
                        parts.push(TO.linkedprojectname);
                    }
                }
                
                // Fallback if nothing exists
                let displayValue = parts.length > 0
                    ? parts.join(" - ")
                    : TO.subject;
                    
                return {
                    value: TO.projectorderid,
                    reference: TO.referenceid,
                    display: displayValue
                }
            });

            return projectOrders;
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    fetchFiles = async (paymentcertificateid) => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data } = await fileCrud.getContractNotificationFiles(companyid, projectid, contractid, paymentcertificateid, this.props.workflowItem.config.documentType)
            const filesList = JSON.parse(data.aggregatelist)
            //this.setState({ files: filesList });
            return filesList;
        } catch (err) {
            if (!axios.isCancel(err)) {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            }
        }
    }

    initialButtonHandler = async (payment) => {
        if (this.state.lastPaymentAmountsRecalculated) {
            const response1 = await this.lastPaymentAmountsRecalculated();

            if (!response1) {
                return; //cancelled
            }
        }

        const response2 = await this.communicateAll();

        if (!response2) {
            return; //cancelled
        }

        this.submitHandler(payment, "COMMUNICATE");
    }

    secondaryButtonHandler = async () => {
        if (this.state.lastPaymentAmountsRecalculated) {
            const response = await this.lastPaymentAmountsRecalculated();

            if (!response) {
                return; //cancelled
            }
        }

        const payment = { ...this.state.batchDrafts };

        this.submitHandler(payment, "SAVE_DRAFT");
    }

    communicateAll = async () => {
        const communicatedToParty = this.props.workflowItem.notifyingParty === "PM" ? this.props.globalResources.SUPPLIER_NAME : this.props.globalResources.PM_NAME
        const warningMessage = this.props.intl.formatMessage({ id: 'CURRENCY_BATCH_MODAL.COMMUNICATE.WARNING' }, { ITEM_NAME: this.props.workflowItem.notificationName, PARTY_NAME: communicatedToParty });
        const warningMessageTitle = this.props.intl.formatMessage({ id: 'CURRENCY_BATCH_MODAL.COMMUNICATE.WARNING_TITLE' });
        let result = await confirm(`<div style="max-width:50vw;">${warningMessage}</div>`, `${warningMessageTitle}`);
        return result;
    }

    lastPaymentAmountsRecalculated = async () => {
        const warningMessage = this.props.intl.formatMessage({ id: 'CURRENCY_BATCH_MODAL.WARNING.LASTPAYMENTCERTIFICATE.RECALCULATED' });
        const warningMessageTitle = this.props.intl.formatMessage({ id: 'CURRENCY_BATCH_MODAL.WARNING.LASTPAYMENTCERTIFICATE.RECALCULATED.WARNING_TITLE' });

        let result = await confirm({
            title: warningMessageTitle,
            message: `<div style="max-width:50vw;">${warningMessage}</div>`,
            showCancelButton: false,
            confirmButtonText: "Ok"
        });

        return result;
    }

    extractValuesByIndex = (items, source, keyPrefix) => {
        if (!Array.isArray(items) || !source || typeof keyPrefix !== 'string') {
            return [];
        }

        return items.map((_, index) => {
            const valueIndex = index + 1;
            const keyWithNumber = `${keyPrefix}${valueIndex}`;
            const keyWithUnderscore = `${keyPrefix}_${valueIndex}`;

            if (keyWithNumber in source) {
                return source[keyWithNumber];
            } else if (keyWithUnderscore in source) {
                return source[keyWithUnderscore];
            } else {
                return null;
            }
        });
    }

    submitHandler = async (payment, mode) => {
        if (payment.assessmentdate) {
            payment.assessmentdatedisplay = moment(payment.assessmentdate).format('DD/MM/YYYY');
        }

        let actioncode = actionCodes.COMMUNICATE;
        let status = 'Communicated';

        if (mode == 'SAVE_DRAFT') {
            actioncode = actionCodes.SAVE_DRAFT;
            status = 'Not Communicated';
        }

        payment.actioncode = actioncode;
        payment.status = status;

        delete payment.subtotalpayment_Total;
        delete payment.subtotalretainTotal;
        delete payment.lastpaymentcertificateamount_Total;
        delete payment.othercumulativepriceTotal;
        delete payment.otheramountpaidTotal;
        delete payment.otheramountretain_Total;
        delete payment.othercertfiedamount_Total;

        const paymentcertificateids = this.state.batchDrafts.map(x => x.paymentcertificateids[0]);
        payment.paymentcertificateids = paymentcertificateids;

        const othercumulativeprices = this.extractValuesByIndex(paymentcertificateids, payment, 'othercumulativeprice');
        payment.othercumulativeprices = othercumulativeprices;

        const otheramountpaids = this.extractValuesByIndex(paymentcertificateids, payment, 'otheramountpaid');
        payment.otheramountpaids = otheramountpaids;

        const subtotalpayments = this.extractValuesByIndex(paymentcertificateids, payment, 'subtotalpayment');
        payment.subtotalpayments = subtotalpayments;

        const subtotalretains = this.extractValuesByIndex(paymentcertificateids, payment, 'subtotalretain');
        payment.subtotalretains = subtotalretains;

        const otheramountretains = this.extractValuesByIndex(paymentcertificateids, payment, 'otheramountretain');
        payment.otheramountretains = otheramountretains;

        let lastpaymentcertificateamounts = this.extractValuesByIndex(paymentcertificateids, payment, 'lastpaymentcertificateamount');
        const isAllNull = lastpaymentcertificateamounts.every(item => item === null);
        if (isAllNull) { //this check added for recalculation scenario
            const valuesArray = Array.from({ length: paymentcertificateids.length }, (_, i) => {
                // Check if the object at this index exists before accessing the key
                const currentEntry = payment[i];
                const key = `lastpaymentcertificateamount${i + 1}`;

                return currentEntry ? currentEntry[key] : null;
            });

            lastpaymentcertificateamounts = valuesArray;
            console.log('All null - extracted from drafts:', lastpaymentcertificateamounts);
        }
        payment.lastpaymentcertificateamounts = lastpaymentcertificateamounts;

        const othercertifiedpretaxes = this.extractValuesByIndex(paymentcertificateids, payment, 'othercertifiedpretax');
        payment.othercertifiedpretaxes = othercertifiedpretaxes;

        const othertaxamounts = this.extractValuesByIndex(paymentcertificateids, payment, 'othertaxamount');
        payment.othertaxamounts = othertaxamounts;

        const othercertfiedamounts = this.extractValuesByIndex(paymentcertificateids, payment, 'othercertfiedamount');
        payment.othercertfiedamounts = othercertfiedamounts;

        // const purchaseOrderNumbers = Object.keys(payment)
        //     .filter(key => key.startsWith('purchaseordernumber'))
        //     .map(key => payment[key]);

        // payment.purchaseOrderNumbers = purchaseOrderNumbers;

        payment.currencies = this.state.currencies;

        payment.summary = this.state.batchDrafts.summary;

        paymentBatchCrud.batchNotify(payment, this.props.contract.contractid, this.props.paymentBatchId)
            .then(() => {
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.SAVED_SUCCESS' }), { variant: 'success', });
                try {
                    if (mode == 'SAVE_DRAFT') {
                        this.props.onValueChanged(false, null);
                        this.getDrafts();
                    } else {
                        this.props.onClose(null, true);
                    }
                }
                catch {
                    this.props.onClose(null, true);
                }
            })
            .catch(err => {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', key: "PersistentFormWarning", persist: true });
            });
    }

    uploadFile = (data, config, paymentcertificateid) => {
        let workflowid = 0;
        if (this.props.workflowItem.config.currentModelType === "Application") {
            workflowid = 21;
        }
        else if (this.props.workflowItem.config.currentModelType === "Certificate") {
            workflowid = 20;
        }
        const { companyid, projectid, contractid } = this.props.contract;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, this.props.workflowItem.config.documentType, paymentcertificateid, workflowid, undefined, data, config)
    }

    calculateDynamicValue = (index, obj, fields) => {
        // fields: array of { key: string, op: "+" | "-" }
        let total = 0;

        fields.forEach(({ key, op }) => {
            let value = obj[`${key}${index}`];

            // Fallback: try in obj[index - 1]
            if (value === undefined && obj[index - 1]) {
                value = obj[index - 1][`${key}${index}`];
            }

            // Default to 0 if still undefined
            value = value || 0;

            // Apply operation
            if (op === "+") {
                total += value;
            } else if (op === "-") {
                total -= value;
            }
        });

        return total;
    };

    calculateDynamicSubTotal = (index, obj) => {
        return this.calculateDynamicValue(index, obj, [
            { key: "othercumulativeprice", op: "+" },
            { key: "otheramountpaid", op: "+" }
        ]);
    };

    calculateDynamicAmountDue = (index, obj) => {
        const prc1 = this.calculateDynamicSubTotal(index, obj);

        let prc2 = obj[`subtotalretain${index}`];

        if (prc2 === undefined) {
            if (prc2 === undefined && obj[index - 1][`subtotalretain${index}`] !== undefined) {
                prc2 = obj[index - 1][`subtotalretain${index}`];
            }
        }

        return (prc1 || 0) - (prc2 || 0);
    };

    calculateDynamicSubTotalPreTax = (index, obj) => {
        const prc1 = this.calculateDynamicAmountDue(index, obj);
        const prc2 = this.calculateLastPaymentAmount(index, obj);

        return (prc1 || 0) - (prc2 || 0);
    };

    calculateDynamicSubTotalPreTaxV2 = (index, obj) => {
        const prc1 = this.calculateDynamicAmountDue(index, obj);
        const prc2 = this.calculateLastPaymentAmount(index);

        return (prc1 || 0) - (prc2 || 0);
    };

    calculateSubTotal = (index, obj) => {
        // const lastPaymentAmount = this.calculateLastPaymentAmount(index);

        // // return lastPaymentAmount != null && lastPaymentAmount != 0
        // //     ? this.calculateDynamicSubTotalPreTax(index, obj)
        // //     : this.calculateDynamicSubTotalPreTaxV2(index, obj);

        // const x = lastPaymentAmount != null && lastPaymentAmount != 0
        //     ? this.calculateDynamicSubTotalPreTax(index, obj)
        //     : this.calculateDynamicSubTotalPreTaxV2(index, obj);

        // return x;

        return this.calculateDynamicSubTotalPreTax(index, obj);
    }
    //     const prc1 = obj[`othercertifiedpretax${index}`] || 0;
    //     const prc2 = obj[`othertaxamount${index}`] || 0;
    //     return prc1 + prc2;
    // };

    // calculateDynamicTotal = (index, obj) => {
    //     return this.calculateDynamicValue(index, obj, [
    //         { key: "othercertifiedpretax", op: "+" },
    //         { key: "othertaxamount", op: "+" }
    //     ]);
    // };

    calculateDynamicTotal = (index, obj) => {
        const prc1 = this.calculateDynamicSubTotalPreTax(index, obj);

        let prc2 = obj[`othertaxamount${index}`];

        if (prc2 === undefined) {
            if (prc2 === undefined && obj[index - 1][`othertaxamount${index}`] !== undefined) {
                prc2 = obj[index - 1][`othertaxamount${index}`];
            }
        }

        return (prc1 || 0) + (prc2 || 0);
    }

    calculateRowTotal = (dataFieldBase, obj) => {
        const columnCount = this.batchPaymentForPackagedContractEnabled ?
            this.state.projectOrders.length :
            this.state.secondaryPrices.length;

        let total = 0;
        for (let i = 1; i <= columnCount; i++) {
            const fieldKey = `${dataFieldBase}${i}`;

            //If fieldKey is undefined, set value and break the loop
            if (fieldKey === 'undefined1') {
                total = this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.TOTAL' });
                break; // Exit the loop
            }

            //This is used for fields where user input is requested
            if (obj[fieldKey] === undefined) {
                const batchDrafts = this.state.batchDrafts;

                if (!batchDrafts || batchDrafts.length === 0) {
                    return 0;
                }

                const fieldKey = `${dataFieldBase}${i}`;

                const draftItem = batchDrafts[i - 1];

                const value = draftItem[fieldKey];

                total += value || 0;
            }

            //The rest is taken from the object
            total += (obj[fieldKey] || 0);
        }

        return total;
    };

    formatCurrency = (index) => {
        const cur = this.currencyCodes.find(currency => currency.code === this.state.currencies[index - 1])?.name;
        return cur;
    }

    formatProjectOrder = (index) => {
        const po = this.state.projectOrders[index - 1]?.display;
        return po;
    }

    calculateLastPaymentAmount = (index, obj) => {
        if (this.props.contract.totalcertified > 0) {
            const { secondaryPricesLastRetainAmounts } = this.state;

            if (secondaryPricesLastRetainAmounts && index > 0) {
                const prc = secondaryPricesLastRetainAmounts[index - 1];

                if (prc && prc.amount !== undefined) {
                    return prc.amount;
                }
            }

            return 0;
        } else {
            let prc = obj[`lastpaymentcertificateamount${index}`];

            if (prc === undefined) {
                if (prc === undefined && obj[index - 1][`lastpaymentcertificateamount${index}`] !== undefined) {
                    prc = obj[index - 1][`lastpaymentcertificateamount${index}`];
                }
            }

            return prc;
        }
    }

    duplicateFieldWithCount(field, count, calculationFunction) {
        const duplicatedFields = [];

        for (let i = 0; i < count; i++) {
            const colIndex = i + 1;

            const duplicatedField = {
                label: `${field.label} ${colIndex}`,
                dataField: `${field.dataField}${colIndex}`,
                required: field.required,
                editorType: field.editorType,
                horizontalfield: true,
                editorOptions: field.editorOptions
            };

            if (i === 0 && field.resource) {
                duplicatedField.resource = field.resource;
            }

            duplicatedField.currency = this.batchPaymentForPackagedContractEnabled ?
                this.props.contract.currency :
                this.state.currencies[i];

            // if (field.value) {
            //     duplicatedField.value = calculationFunction ? calculationFunction.bind(null, i + 1) : undefined;
            // }

            if (field.value && field.dataField !== 'lastpaymentcertificateamount') {
                duplicatedField.value = field.value.bind(null, colIndex);
            }

            duplicatedFields.push(duplicatedField);
        }

        return duplicatedFields;
    }

    generateFieldsWithDuplicates(fields) {
        const updatedFields = [];

        fields.forEach(field => {
            if (field.columnCount) {
                // 1. Generate the standard duplicated fields (Project Order 1, 2, etc.)
                const duplicatedFields = this.duplicateFieldWithCount(field, field.columnCount, field.value);

                // 2. Add the Total column only if batch payment for packaged contract is enabled
                if (this.batchPaymentForPackagedContractEnabled) {
                    // Create the Total field definition
                    const totalField = {
                        label: this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.TOTAL' }),
                        dataField: `${field.dataField}Total`,
                        editorType: field.hasOwnProperty('dataField') ? 'dxNumberBox' : 'dxTextBox', //For total label, we use TextBox
                        horizontalfield: true,
                        readOnly: true,
                        value: this.calculateRowTotal.bind(this, field.dataField),
                        editorOptions: {
                            currency: this.props.contract.currency,
                            readOnly: true,
                            elementAttr: { class: 'text-right' }
                        }
                    };
                    duplicatedFields.push(totalField);
                }

                const transformedField = {
                    horizontalrow: true,
                    ...(field.label && { label: field.label }),
                    ...(field.resource && { resource: field.resource }),
                    // The horizontalfields array now contains the base columns and, optionally, the Total column
                    horizontalfields: duplicatedFields.map(duplicatedField => ({ ...duplicatedField }))
                };
                updatedFields.push(transformedField);
            } else {
                updatedFields.push(field);
            }
        });

        return updatedFields;
    }

    mapBatchDrafts = (batchDrafts, projectOrders) => {
        return batchDrafts.map((item, index) => {
            const newItem = { ...item };

            const i = index + 1;

            if (Array.isArray(item.subtotalpayments) && item.subtotalpayments.length > 0) {
                newItem[`subtotalpayment${i}`] = item.subtotalpayments[0];
            }
            if (Array.isArray(item.subtotalretains) && item.subtotalretains.length > 0) {
                newItem[`subtotalretain${i}`] = item.subtotalretains[0];
            }
            if (Array.isArray(item.lastpaymentcertificateamounts) && item.lastpaymentcertificateamounts.length > 0) {
                newItem[`lastpaymentcertificateamount${i}`] = item.lastpaymentcertificateamounts[0];
            }
            if (Array.isArray(item.othercumulativeprices) && item.othercumulativeprices.length > 0) {
                newItem[`othercumulativeprice${i}`] = item.othercumulativeprices[0];
            }
            if (Array.isArray(item.otheramountpaids) && item.otheramountpaids.length > 0) {
                newItem[`otheramountpaid${i}`] = item.otheramountpaids[0];
            }
            if (Array.isArray(item.otheramountretains) && item.otheramountretains.length > 0) {
                newItem[`otheramountretain${i}`] = item.otheramountretains[0];
            }
            if (Array.isArray(item.othercertifiedpretaxes) && item.othercertifiedpretaxes.length > 0) {
                newItem[`othercertifiedpretax${i}`] = item.othercertifiedpretaxes[0];
            }
            if (Array.isArray(item.othertaxamounts) && item.othertaxamounts.length > 0) {
                newItem[`othertaxamount${i}`] = item.othertaxamounts[0];
            }
            if (Array.isArray(item.othercertfiedamounts) && item.othercertfiedamounts.length > 0) {
                newItem[`othercertfiedamount${i}`] = item.othercertfiedamounts[0];
            }
            if (Array.isArray(item.currencies) && item.currencies.length > 0) {
                newItem[`currency${i}`] = item.currencies[0];
            }
            if (this.batchPaymentForPackagedContractEnabled && Array.isArray(item.projectorders) && item.projectorders.length > 0) {
                newItem[`projectorderid${i}`] = item.projectorders[0];
                newItem[`projectorderreference${i}`] = projectOrders.find(x => x.value === item.projectorders[0]).reference;
            }

            delete newItem.subtotalpayments;
            delete newItem.subtotalretains;
            delete newItem.lastpaymentcertificateamounts;
            delete newItem.othercumulativeprices;
            delete newItem.otheramountpaids;
            delete newItem.otheramountretains;
            delete newItem.othercertifiedpretaxes;
            delete newItem.othertaxamounts;
            delete newItem.othercertfiedamounts;
            delete newItem.currencies;

            return newItem;
        });
    }

    onValueChanged = async (field, value) => {
        this.props.onValueChanged(true, null);
        if (field) {
            this.state.batchDrafts[field] = value;
        }
    }

    render() {
        const { companyid, projectid, contractid } = this.props.contract;

        if ((this.props.paymentBatchId && !this.state.batchDrafts) ||
            (this.batchPaymentForPackagedContractEnabled && !this.state.projectOrders) ||
            !this.state.secondaryPricesLastRetainAmounts) {
            return (<PortletSpinner />);
        }

        const bottomLabel = this.props.workflowItem.config.currentModelType === 'Application' ? this.props.resources.PaymentAppliedPeriodLabel : this.props.resources.PaymentCertifiedPeriodLabel;

        const columnCount = this.state.batchDrafts ? this.state.batchDrafts.length : 1;

        const createFormConfig = {
            currencyCode: this.props.contract.currency,
            buttonResource: "PAYMENT.BATCH_WIZARD.BUTTON.COMMUNICATE",
            fields: []
        };

        if (this.configurableTypeFields) {
            createFormConfig.fields.push(
                { resource: "GENERAL.FIELD.APPLICATIONTYPE", dataField: 'paymenttype', editorType: 'dxSelectBox', editorOptions: { dataSource: this.configurableTypeFields, valueExpr: 'value', displayExpr: 'display' } })
        }

        createFormConfig.fields.push(
            { label: this.props.resources.AssessmentDayLabel, dataField: 'assessmentdate', required: true, editorType: 'dxDateBox' },
            { label: this.props.resources.SummaryDetailsLabel, dataField: 'summary', required: true, editorType: 'dxHtmlEditor', },
        )

        if (this.batchPaymentForPackagedContractEnabled) {
            // Add the 'Total' label to the end of the Project Order references
            const horizontalLabels = [
                ...this.state.projectOrders.map(x => x.reference),
                this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.TOTAL' }) //Added Total Label
            ];

            createFormConfig.fields.push(
                { horizontallabels: horizontalLabels },
                { label: this.projectOrderNotificationName, value: this.formatProjectOrder, editorType: 'dxTextArea', columnCount: columnCount, editorOptions: { autoResizeEnabled: true } },
            )
        } else {
            createFormConfig.fields.push(
                { horizontallabels: this.state.currencies },
                { resource: "GENERAL.FORMS.CURRENCY", value: this.formatCurrency, editorType: 'dxTextBox', columnCount: columnCount },
            )
        }

        createFormConfig.fields.push(
            { label: this.props.resources.CumulativePriceLabel, dataField: 'othercumulativeprice', required: true, editorType: 'dxNumberBox', columnCount: columnCount, ...rightAlignedNumberBox },
            { label: this.props.resources.PlusAmountsSupplierLabel, dataField: 'otheramountpaid', required: true, editorType: 'dxNumberBox', columnCount: columnCount, ...rightAlignedNumberBox },
            { resource: "CONTRACT.WF.PAYMENT.FIELD.SUB_TOTAL", dataField: 'subtotalpayment_', required: true, editorType: 'dxNumberBox', value: this.calculateDynamicSubTotal, columnCount: columnCount, ...rightAlignedNumberBox },
            { label: this.props.resources.LessAmountsSupplierLabel, dataField: 'subtotalretain', required: true, editorType: 'dxNumberBox', editorOptions: { min: 0 }, columnCount: columnCount, ...rightAlignedNumberBox },
            { resource: "CONTRACT.WF.PAYMENT.FIELD.AMOUNT_DUE", dataField: 'otheramountretain_', required: true, editorType: 'dxNumberBox', value: this.calculateDynamicAmountDue, columnCount: columnCount, ...rightAlignedNumberBox },
            //{ label: this.props.resources.LessAmountsDueLabel, dataField: 'lastpaymentcertificateamount_', required: true, editorType: 'dxNumberBox', value: this.calculateLastPaymentAmount, columnCount: columnCount, ...rightAlignedNumberBox },
        )
        // if (this.props.contract.totalcertified != null) {
        //     const lastPaymentField = createFormConfig.fields.find(itm => itm.dataField === 'lastpaymentcertificateamount');
        //     lastPaymentField.value = () => this.props.contract.totalcertified;
        // }

        if (this.props.contract.totalcertified != null) {
            createFormConfig.fields.push(
                { label: this.props.resources.LessAmountsDueLabel, dataField: 'lastpaymentcertificateamount', required: true, editorType: 'dxNumberBox', /*value: this.calculateLastPaymentAmount,*/ columnCount: columnCount, editorOptions: { elementAttr: { class: 'text-right' }, readOnly: true }/*, ...rightAlignedNumberBox*/ }
            )
        } else {
            createFormConfig.fields.push(
                { label: this.props.resources.LessAmountsDueLabel, dataField: 'lastpaymentcertificateamount', required: true, editorType: 'dxNumberBox', columnCount: columnCount, ...rightAlignedNumberBox }
            )
        }

        if (this.taxEnabled) {
            createFormConfig.fields.push(
                { resource: "CONTRACT.WF.PAYMENT.FIELD.SUB_TOTAL", dataField: 'othercertifiedpretax_', required: true, editorType: 'dxNumberBox', value: this.calculateSubTotal, columnCount: columnCount, ...rightAlignedNumberBox },
                { label: this.props.resources.TaxSupplierLabel, dataField: 'othertaxamount', required: true, editorType: 'dxNumberBox', columnCount: columnCount, ...rightAlignedNumberBox },
                { label: bottomLabel, dataField: 'othercertfiedamount_', required: true, editorType: 'dxNumberBox', value: this.calculateDynamicTotal, columnCount: columnCount, ...rightAlignedNumberBox }
            )
        }
        else {
            createFormConfig.fields.push(
                { label: bottomLabel, dataField: 'othercertfiedamount_', required: true, editorType: 'dxNumberBox', value: this.calculateSubTotal, columnCount: columnCount, ...rightAlignedNumberBox }
            )
        }

        if (this.poNumberEnabled) {
            createFormConfig.fields.push(
                { resource: 'CONTRACT.FIELD.PO_NUMBER', dataField: 'purchaseordernumber', required: false, editorOptions: { defaultValue: this.props.contract.versionnumber } }
            )
        }

        const updatedFields = this.generateFieldsWithDuplicates(createFormConfig.fields);

        return (
            <div style={{ marginTop: 10 }}>
                {
                    <div style={{ height: 'calc(100vh - 225px)', overflowY: 'auto' }}>
                        <Portlet>
                            <PortletBody style={{ maxWidth: 1001, height: 'auto' }}>
                                <ValidationGroup ref={this.validatorRef} name={this.validatorName}>
                                    <BiDynamicForm
                                        {...this.props}
                                        onSubmitHandler={this.initialButtonHandler}
                                        buttonDisabled={!this.communicateButtonEnabled}
                                        item={this.state.batchDrafts}
                                        config={{ ...createFormConfig, fields: updatedFields }}
                                        customFields={(this.customFields || {}).COMMUNICATION}
                                        valueChangeHandler={this.onValueChanged}
                                        externalFileUploadItems={this.state.batchDrafts}
                                        batchPaymentForPackagedContractEnabled={this.batchPaymentForPackagedContractEnabled}
                                        secondaryButtonEnabled={true}
                                        secondaryButtonActive={true}
                                        secondaryButtonDeactiveText={this.props.intl.formatMessage({ id: "PAYMENT.BATCH_WIZARD.BUTTON.EXIT_WIZARD" })}
                                        secondaryButtonHandler={this.secondaryButtonHandler}
                                        secondaryButtonDeactiveStyle={{ width: "112px" }}
                                        onUploadFile={this.uploadFile}
                                        onDeleteContractFile={(fileid) => { return fileCrud.deleteContractFile(companyid, projectid, contractid, fileid) }}
                                        onFilesCountChanged={this.props.onFilesCountChanged}
                                        onFileUploadFinish={() => this.setState({ fileUploading: false })}
                                        onFileUploadStart={() => this.setState({ fileUploading: true })}
                                    />
                                </ValidationGroup>
                            </PortletBody>
                        </Portlet>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
});

export default injectIntl(withSnackbar(connect(mapStateToProps)(NotifyDocumentPage)));
